import StarFilled16 from '@carbon/icons-react/es/star--filled/16';
import React, { FC } from 'react';
import styled from 'styled-components';
import { BaseCell } from 'components/organisms/timesheets/common/timesheet-table';

const Cell = styled(BaseCell)`
  display: flex;
  gap: var(--spacing-02);

  svg {
    color: var(--yellow-50);
  }
`;

export const CsatCell: FC<{ value: number }> = ({ value }) => (
  <Cell>
    {value == null ? (
      '-'
    ) : (
      <>
        <StarFilled16 /> {value}
      </>
    )}
  </Cell>
);
